import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { getImportTypeByKey, } from "../components/import/importTypesConfig";
var QUERY_PARAM = "import";
export var useSelectedImport = function () {
    var history = useHistory();
    var queryParams = new URLSearchParams(history.location.search);
    var importKey = queryParams.get(QUERY_PARAM);
    var selectedImportKey = importKey && getImportTypeByKey(importKey)
        ? importKey
        : null;
    var setSelectedImport = useCallback(function (importKey) {
        var queryParams = new URLSearchParams(history.location.search);
        if (importKey && getImportTypeByKey(importKey)) {
            queryParams.set(QUERY_PARAM, importKey);
        }
        else {
            queryParams.delete(QUERY_PARAM);
        }
        history.push({ search: queryParams.toString() });
    }, [history]);
    return {
        selectedImportKey: selectedImportKey,
        setSelectedImport: setSelectedImport,
    };
};
